import { PortalTheme, UserOnboardingDepartment, UserOnboardingJobLevel, UserSource, UserTheme, } from "@supernova-studio/model";
import { DTOUser, DTOUserProfile } from "./user";
import { z } from "zod";
//
// Entities
//
export const DTOUserOnboardingDepartment = UserOnboardingDepartment;
export const DTOUserOnboardingJobLevel = UserOnboardingJobLevel;
export const DTOUserSource = UserSource;
export const DTOUserTheme = UserTheme;
export const DTOUserPortalTheme = PortalTheme;
export const DTOUserOnboarding = z.object({
    companyName: z.string().optional(),
    numberOfPeopleInOrg: z.string().optional(),
    numberOfPeopleInDesignTeam: z.string().optional(),
    department: DTOUserOnboardingDepartment.optional(),
    jobTitle: z.string().optional(),
    phase: z.string().optional(),
    jobLevel: DTOUserOnboardingJobLevel.optional(),
    designSystemName: z.string().optional(),
    defaultDestination: z.string().optional(),
    isPageDraftOnboardingFinished: z.boolean().optional(),
    figmaUrl: z.string().optional(),
    isApprovalsOnboardingFinished: z.boolean().optional(),
});
export const DTOAuthenticatedUserProfile = DTOUserProfile.extend({
    onboarding: DTOUserOnboarding.optional(),
    theme: DTOUserTheme.optional(),
    portalTheme: DTOUserPortalTheme.optional(),
});
export const DTOUserEmailSettings = z.object({
    marketingEmails: z.boolean(),
});
export const DTOAuthenticatedUser = DTOUser.extend({
    profile: DTOAuthenticatedUserProfile,
    emailSettings: DTOUserEmailSettings,
    createdAt: z.coerce.date(),
    loggedOutAt: z.coerce.date().optional(),
    source: DTOUserSource.optional(),
});
//
// Payloads - input
//
export const DTOUserProfileUpdatePayload = DTOAuthenticatedUserProfile.partial().omit({
    avatar: true,
});
export const DTOUserEmailSettingsUpdatePayload = DTOUserEmailSettings.partial();
export const DTOUserUpdatePayload = z.object({
    profile: DTOUserProfileUpdatePayload.optional(),
    emailSettings: DTOUserEmailSettingsUpdatePayload.optional(),
    avatarFileId: z.string().optional(),
});
//
// Payloads - output
//
export const DTOAuthenticatedUserResponse = z.object({
    user: DTOAuthenticatedUser,
});
